<ng-container *ngIf="hasError">
    <div class="header">
      <h2 i18n>EDITOR CAN'T BE LOADED</h2>
    </div>
    <div class="content">
      <pre>
          {{ error.message }}
      </pre>
    </div>
</ng-container>

<ng-container *ngIf="!isReady && !hasError">
    <div class="header">
      <h2 i18n>EDITOR IS PREPARING...</h2>
    </div>
    <div class="content">
      <p i18n>Please wait we're loading workflow and necessary data.</p>
    </div>
</ng-container>

<ng-container *ngIf="isReady && !hasError">
    <ng-container *ngIf="!shouldShowSection('workflow-create')">
      <div class="header">
        <h2>{{ getWorkflowName() }} <button mat-icon-button (click)="onEdit()"><mat-icon>edit</mat-icon></button></h2>
        <eas-workflow-audit-result-button [result]="auditResult"></eas-workflow-audit-result-button>
      </div>

      <div class="section-slector">
        <mat-button-toggle-group name="editorSectionToggle"
                                 aria-label="Editor section"
                                 i18n-aria-label
                                 (change)="onSectionChange($event)">
            <mat-button-toggle value="transitions" i18n>Transitions</mat-button-toggle>
            <mat-button-toggle value="states" i18n>States</mat-button-toggle>
            <mat-button-toggle value="form" i18n>Form</mat-button-toggle>
        </mat-button-toggle-group>
      </div>

      <div class="content">
        <eas-workflow-transitions-editor *ngIf="shouldShowSection('workflow-transitions')">
        </eas-workflow-transitions-editor>
      
        <eas-workflow-form-editor *ngIf="shouldShowSection('workflow-form')">
        </eas-workflow-form-editor>
      
        <eas-workflow-states-editor *ngIf="shouldShowSection('workflow-states')">
        </eas-workflow-states-editor>
      </div>
    </ng-container>

    <ng-container *ngIf="shouldShowSection('workflow-create')">
      <div class="content">
        <eas-workflow-create-form [availableRoles]="availableRoles"
                                  (didContinue)="onCreate($event)">
        </eas-workflow-create-form>
      </div>
    </ng-container>
</ng-container>
